<template>
  <div class="one-survey-edit">
    <div class="text-right">
      <b-button @click="isEditing = !isEditing" type="button" variant="primary"
        >編輯</b-button
      >
    </div>
    <b-form>
      <b-form-group
        label="標題"
        label-for="one-survey-edit-title"
        class="required-icon-star"
      >
        <b-form-input
          id="one-survey-edit-title"
          :value="$store.getters.oneSurvey.title"
          @input="$store.commit('oneSurveyTitle', $event)"
          :state="verifyTitle"
          :title="'請輸入值'"
          type="text"
          :disabled="!isEditing"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="發布日期" class="required-icon-star">
        <b-form-datepicker
          :value="$store.getters.oneSurvey.released_at"
          @input="$store.commit('oneSurveyReleasedAt', $event)"
          :state="verifyDate"
          :title="'請輸入值'"
          :date-format-options="{
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
          }"
          placeholder="請選擇發布日期"
          :disabled="!isEditing"
        >
        </b-form-datepicker>
      </b-form-group>
      <b-form-group label="內容" label-for="one-survey-edit-content">
        <editor
          :value="$store.getters.oneSurvey.content"
          @input="$store.commit('oneSurveyContent', $event)"
          :isReadOnly="!isEditing"
        ></editor>
      </b-form-group>
    </b-form>
    <div class="text-right">
      <b-button
        class="mr-3"
        type="button"
        variant="primary"
        @click="verifyForm"
        :disabled="!isEditing"
        >修改</b-button
      >
      <b-button
        class="mr-3"
        type="button"
        variant="dark"
        @click="$router.push({ name: 'survey-owner' })"
        :disabled="!isEditing"
        >取消</b-button
      >
    </div>
  </div>
</template>

<script>
import mixinsVerify from "@/utility/mixinsVerify.js";
import editor from "@/components/Editor.vue";
export default {
  mixins: [mixinsVerify],
  components: {
    editor
  },
  data() {
    return {
      createForm: {
        research_title: "test",
        released_at: "2020-09-18",
        research_content: ""
      },
      verifyTitle: null,
      verifyDate: null,
      isEditing: false
    };
  },
  methods: {
    verifyForm() {
      this.verifyTitle = this.hasValue(this.$store.getters.oneSurvey.title);
      this.verifyDate = this.hasValue(
        this.$store.getters.oneSurvey.released_at
      );
      if (this.verifyTitle === false || this.verifyDate === false) return;
      else this.submit();
    },
    submit() {
      //from YYYY-MM-DD format to YYYY/MM/DD
      let regex = /-/gi;
      const formatDate = this.$store.getters.oneSurvey["released_at"].replace(
        regex,
        "/"
      );
      const postData = {
        research_title: this.$store.getters.oneSurvey.title,
        research_content: this.$store.getters.oneSurvey.content,
        released_at: formatDate
      };
      this.$store.dispatch("updateOneSurvey", postData).then(() => {
        this.$router.push({ name: "survey-owner" });
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
